import { useContext } from 'react';
import { SubscriptionsContext } from "../contexts/SubscriptionsContext";

// ----------------------------------------------------------------------

const useSubscriptions = () => {
    const context = useContext(SubscriptionsContext);
    if (!context) throw new Error('Subscription context must be use inside SubscriptionContextProvider');

    return context;
};

export default useSubscriptions;
